export default __webpack_public_path__ + "static/media/mediaTwo.6a25f8e8.jpg";